/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, position: NonNullable<unknown>, total: NonNullable<unknown> }} Settings_Templates_Drag_OverInputs */



/**
* | output |
* | --- |
* | "{name} is now in position {position} of {total}." |
*
* @param {Settings_Templates_Drag_OverInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_templates_drag_over = /** @type {((inputs: Settings_Templates_Drag_OverInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Templates_Drag_OverInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.name} staat nu op plaats ${i?.position} van ${i?.total}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} est maintenant en position ${i?.position} sur ${i?.total}.`)
	return /** @type {LocalizedString} */ (`${i?.name} is now in position ${i?.position} of ${i?.total}.`)
});